var map = {
	"./ch/PC_01.jpg": "e8de",
	"./ch/PC_02.jpg": "8c3b",
	"./ch/PC_03.jpg": "ade0",
	"./ch/PC_04.jpg": "19c5",
	"./ch/PC_05.jpg": "1b44",
	"./ch/PC_06.jpg": "1cda",
	"./ch/PC_07.jpg": "b98d",
	"./en/PC_01.jpg": "06d0",
	"./en/PC_02.jpg": "877e",
	"./en/PC_03.jpg": "a65e",
	"./en/PC_04.jpg": "695e",
	"./en/PC_05.jpg": "6714",
	"./en/PC_06.jpg": "06ac",
	"./en/PC_07.jpg": "37b8",
	"./zh/PC_01.jpg": "f1d9",
	"./zh/PC_02.jpg": "80a7",
	"./zh/PC_03.jpg": "f32d",
	"./zh/PC_04.jpg": "160a",
	"./zh/PC_05.jpg": "7c3e",
	"./zh/PC_06.jpg": "94af",
	"./zh/PC_07.jpg": "573c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba03";